import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material"
import SkeletonImage from "../../../../components/common/SkeletonImage"
import DocViewer from "../../../../components/common/DocViewer"
import { FILE_PATH_URI, handleDownload } from "../../../../utils/helper"
import Icons from "../../../../assets/js/Icons"
import { Fragment } from "react"
import moment from "moment"

function TrustSafety({ specialist }) {

  return (
    <Fragment>
      <Typography sx={{ fontSize: "24px", fontWeight: "600" }}>Trust & safety</Typography>
      <TableContainer
        className="adminTable2"
      // sx={{ "tr:last-child :is(td, th)": { borderBottom: "none" } }}
      >
        <Table stickyHeader>
          <TableBody>
            <TableRow>
              <TableCell component="th">Full name</TableCell>
              <TableCell>{specialist?.fullName}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th">Date of Birth</TableCell>
              <TableCell>{moment(specialist?.background?.dob).format("DD-MMM-YYYY")}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th">Personal Identification</TableCell>
              <TableCell>
                <Box
                  sx={{
                    width: "250px",
                    borderRadius: 2,
                    overflow: "hidden",
                    aspectRatio: "1/1",
                    position: "relative",
                    display: "inline-block",
                  }}
                >
                  {specialist?.background?.personalIdentification?.[0]?.path &&
                    <IconButton
                      sx={{
                        top: "10px",
                        right: "10px",
                        border: "1px solid",
                        position: "absolute",
                        color: "primary.main",
                        bgcolor: "white !important",
                        borderColor: "primary.main"
                      }}
                      size="small"
                      onClick={() => { handleDownload(FILE_PATH_URI + specialist?.background?.personalIdentification?.[0]?.path) }}
                    ><Icons.CloudDownloadSolid />
                    </IconButton>
                  }
                  <SkeletonImage src={FILE_PATH_URI + specialist?.background?.personalIdentification?.[0]?.path} />
                </Box>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th">Professional Identification</TableCell>
              <TableCell>
                <Box
                  sx={{
                    width: "250px",
                    borderRadius: 2,
                    overflow: "hidden",
                    aspectRatio: "1/1",
                    position: "relative",
                    display: "inline-block",
                  }}
                >
                  {specialist?.background?.professionalIdentification?.[0]?.path &&
                    <IconButton
                      sx={{
                        top: "10px",
                        right: "10px",
                        border: "1px solid",
                        position: "absolute",
                        color: "primary.main",
                        bgcolor: "white !important",
                        borderColor: "primary.main"
                      }}
                      size="small"
                      onClick={() => { handleDownload(FILE_PATH_URI + specialist?.background?.professionalIdentification?.[0]?.path) }}
                    ><Icons.CloudDownloadSolid />
                    </IconButton>
                  }
                  <SkeletonImage src={FILE_PATH_URI + specialist?.background?.professionalIdentification?.[0]?.path} />
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <DocViewer />
    </Fragment>
  )
}

export default TrustSafety